import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Zap, Clock, MousePointer, Webhook } from 'lucide-react';
import { TRIGGER_TYPES } from '../../../constants';

const triggerIcons = {
  [TRIGGER_TYPES.EVENT]: Zap,
  [TRIGGER_TYPES.SCHEDULE]: Clock,
  [TRIGGER_TYPES.MANUAL]: MousePointer,
  [TRIGGER_TYPES.WEBHOOK]: Webhook,
};

const TriggerNode = ({ data, selected }) => {
  const Icon = triggerIcons[data.triggerType] || Zap;

  return (
    <div className={`px-4 py-3 rounded-lg border-2 bg-white shadow-md min-w-[200px] transition-shadow ${
      selected ? 'border-blue-600 shadow-lg ring-2 ring-blue-200' : 'border-blue-500'
    }`}>
      <div className="flex items-center gap-2">
        <div className="p-1.5 rounded bg-blue-50">
          <Icon className="text-blue-500" size={16} />
        </div>
        <span className="font-medium text-sm text-blue-700">When...</span>
      </div>
      <div className="text-xs text-gray-600 mt-1.5 truncate">
        {data.label || 'Select a trigger'}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        className="!bg-blue-500 !w-3 !h-3 !border-2 !border-white"
      />
    </div>
  );
};

export default TriggerNode;
